import HelpTip from '../../../components/HelpTip';

interface PromptTextareaSectionProps {
  title: string;
  helpText: string;
  description: string;
  value: string;
  rows: number;
  placeholder: string;
  onChange: (value: string) => void;
}

export default function PromptTextareaSection({
  title,
  helpText,
  description,
  value,
  rows,
  placeholder,
  onChange,
}: PromptTextareaSectionProps) {
  return (
    <div style={{ borderTop: '1px solid var(--border)', paddingTop: '0.75rem' }}>
      <p style={{ margin: '0 0 0.5rem', fontSize: '0.82rem', fontWeight: 600, color: 'var(--text-2)' }}>
        {title}
        <HelpTip text={helpText} />
      </p>
      <p style={{ margin: '0 0 0.4rem', fontSize: '0.78rem', color: 'var(--text-2)' }}>{description}</p>
      <textarea
        value={value}
        onChange={event => onChange(event.target.value)}
        rows={rows}
        style={{ width: '100%', fontSize: '0.82rem', border: '1px solid var(--border)', borderRadius: '4px', padding: '4px 8px', resize: 'vertical', boxSizing: 'border-box' }}
        placeholder={placeholder}
      />
    </div>
  );
}
